// src/components/navigation/fab-context.tsx
import { createContext, useContext, useState, type ReactNode } from "react";
import { type LucideIcon } from "lucide-react";

export interface FabAction {
    icon: LucideIcon;
    label: string;
    onClick: () => void;
    color?: "primary" | "secondary" | "tertiary";
    disabled?: boolean;
}

interface FabContextType {
    action: FabAction | null;
    setAction: (action: FabAction | null) => void;
}

const FabContext = createContext<FabContextType | undefined>(undefined);

export function useFab() {
    const context = useContext(FabContext);
    if (!context) {
        throw new Error("useFab must be used within a FabProvider");
    }
    return context;
}

interface FabProviderProps {
    children: ReactNode;
}

export function FabProvider({ children }: FabProviderProps) {
    const [action, setAction] = useState<FabAction | null>(null);

    return (
        <FabContext.Provider value={{ action, setAction }}>
            {children}
        </FabContext.Provider>
    );
}
